<script>
  export let product;
  let ratingNearestTenth = Math.round(10 * Number(product.product.reviews_average_score)) / 10;
  let ratingNearestHalf = Math.round(2 * Number(product.product.reviews_average_score)) / 2;

  let ratingNearestHalfInteger = Math.floor(ratingNearestHalf);
  let isRatingNearestHalfDecimal = (ratingNearestHalf - ratingNearestHalfInteger) > 0;

  let emptyStarCount = 5 - ratingNearestHalfInteger;
  if (isRatingNearestHalfDecimal) {
    emptyStarCount = 4 - ratingNearestHalfInteger;
  }
</script>

{#if product}
  <div
    class="yotpo bottomLine"
    data-product-id="{product.id}"
    data-product-models="{product.id}"
    data-name="{product.title}"
    data-description="{product.description}"
    data-alignment="center"
    data-hide-reviews="true"
  >
    <div class="yotpo-display-wrapper" aria-hidden="false" style="">
      <div class="standalone-bottomline" data-source="offload">
        <div class="yotpo-bottomline pull-left star-clickable" tabindex="0">
          <span class="yotpo-stars">
            {#each Array(ratingNearestHalfInteger) as _, i}
              <span class="yotpo-icon yotpo-icon-star rating-star pull-left"></span>
            {/each}

            {#if isRatingNearestHalfDecimal}
              <span class="yotpo-icon yotpo-icon-half-star rating-star pull-left"></span>
            {/if}

            {#each Array(emptyStarCount) as _, i}
              <span class="yotpo-icon yotpo-icon-empty-star rating-star pull-left"></span>
            {/each}
            
            <span class="sr-only">{ratingNearestTenth} star rating</span>
          </span>
          <p class="text-m" aria-label="{product.product.total_reviews} reviews">
            {product.product.total_reviews} Reviews
          </p>
          <div class="yotpo-clr"></div>
        </div>
        <div class="yotpo-clr"></div>
      </div>
      <div class="yotpo-clr"></div>
    </div>
  </div>
{/if}